export default __webpack_public_path__ + "static/media/main_saying01_jp.dafbcc97.png";